import React, {useEffect, useState} from 'react'
import {Button, message, Spin, Tabs,Form,Input,Select} from 'antd';
import styled from 'styled-components'

import {MarkdownEditor} from '../../../components/MarkdownEditor';
import {useTranslation} from 'react-i18next';
import {editMfInfo, getMfInfo} from "../../../api/User";
import { CustomInput } from '../../../components/CustomForm';

const Container = styled.div`
  padding: 20px;
`

const SubmitButton = styled(Button)`
  margin-top: 40px;
  height: 42px;
  background-color: #18EAC4;
  color: #0e0e0e;
  border: none;
`

export const Policy = () => {
    const [MaxRewardValue, setMaxRewardValue] = useState('');
    const [RewardSymbolValue, setRewardSymbolValue] = useState('');
    const [TextAreaValue, setTextAreaValue] = useState('');
    const [pageLoading, setPageLoading] = useState(false);

    const { t } = useTranslation();

    const getUserInfo = async () => {
        setPageLoading(true);
        try {
            const { code, data } = await getMfInfo();
            if (code === '10000') {
                setTextAreaValue(data.company.policy)
                setMaxRewardValue(data.company.max_reward)
                setRewardSymbolValue(data.company.reward_symbol)
            }
        } catch (error) {
            setPageLoading(false);
        }
        setPageLoading(false);
    };

    useEffect(() => {
        getUserInfo()
    }, [])

    const items = [{
        label: 'Write', key: '1', children: (
            <MarkdownEditor
                mode={1}
                value={TextAreaValue}
                height={500}
                onChange={({text, html}) => setTextAreaValue(text)} />
        )
    }, {
        label: 'Preview', key: '2', children: (
            <MarkdownEditor
                mode={2}
                value={TextAreaValue}
                height={500} />
        )
    }]

    const submit = async () => {
        const { code } = await editMfInfo({
            max_reward: MaxRewardValue,
            reward_symbol: RewardSymbolValue,
            policy: TextAreaValue,
        });
        if (code === '10000') {
            message.success(t('updateSuccessful'));
        }
    }

    const onNumberChange = (e) => {
        setMaxRewardValue(e.target.value);
    }

    const onSymbolChange = (newCurrency) => {
        setRewardSymbolValue(newCurrency);
    }

    return (
        <Spin spinning={pageLoading}>
            <Container>
                <Form>
                    <Form.Item
                        label={t('user_center.CompanyInfo.maxReward')}
                        name={'max_reward'}
                    >
                        <CustomInput
                            type="text"
                            value={MaxRewardValue}
                            onChange={onNumberChange}
                            style={{ width: 200,textAlign: 'right' }}
                            className="personal-input"
                            placeholder={'reward amount'}
                        />
                        <Select
                            value={RewardSymbolValue}
                            className='project-policy'
                            style={{ width: '120px'}}
                            onChange={onSymbolChange}
                            placeholder='currency'
                            options={[
                                {
                                value: '$',
                                label: 'USD',
                                },
                                {
                                value: 'USDC',
                                label: 'USDC',
                                },
                                {
                                value: 'ETH',
                                label: 'ETH',
                                },
                                {
                                value: 'BTC',
                                label: 'BTC',
                                }
                            ]}
                        />
                    </Form.Item>

                </Form>

                
                
                <Tabs
                    type='card'
                    tabPosition={'bottom'}
                    tabBarGutter={0}
                    tabBarStyle={{
                        marginTop: 0,
                    }}
                    items={items}
                 />

            <Button
              type="primary"
              htmlType="submit"
              onClick={submit}
              style={{
                backgroundColor: '#18EAC4',
                color: '#000000',
                borderColor: '#18EAC4',
                borderRadius: '4px',
                marginTop: '20px'
              }}
            >
                    {t('addreport.submit')}
            </Button>
            </Container>
        </Spin>
    )
}
